import { PEOPLE_BY_EMAIL_DOMAIN_QUERY } from '@src/gql/person-gql';
import { extractErrorInfo } from '@src/utility/error';
import { LogManager } from '@src/utility/Logger';
import { fetchAllGraphqlPages } from '@src/utility/paginateGraphql';

import type { GraphQLClient } from 'graphql-request';

const logger = LogManager.getLogger('repository:PersonRepository');

export interface PersonSummary {
  name: string;
}

export class PersonRepository {
  constructor(private gqlClient: GraphQLClient) {}

  /**
   * People whose email address belongs to `domain` (e.g. `tryarbor.com`).
   * Returns an empty list on failure — callers use this to decide what to hide,
   * so a failed lookup must degrade to "hide nothing", never to an error.
   */
  async findByEmailDomain(domain: string): Promise<PersonSummary[]> {
    try {
      return await fetchAllGraphqlPages<PersonSummary>(
        this.gqlClient,
        PEOPLE_BY_EMAIL_DOMAIN_QUERY,
        'allPeople',
        // Anchored regexp: a plain `matches` is a substring test, which
        // `foo@tryarbor.com.example.org` would also satisfy.
        { pattern: `@${domain.replace(/\./g, '\\.')}$` },
      );
    } catch (error) {
      logger.warn('Failed to fetch people by email domain', {
        domain,
        ...extractErrorInfo(error),
      });
      return [];
    }
  }
}
